import {convertInquiryTypeToText, convertMailTypeToText} from "../../../utils/helpler-utils";

export default {
    SET_LIST_MAIL_TRASH(state, listMailTrash) {
        let result = [];
        if (listMailTrash && listMailTrash.length > 0) {
            result = listMailTrash.map(element => {
                if (typeof element.state_flg !== 'undefined') {
                    if (element.state_flg === -1) {
                        element.state_flg_text = '削除'
                    } else if (element.state_flg === 0) {
                        element.state_flg_text = '未対応'
                    } else if (element.state_flg === 1) {
                        element.state_flg_text = '対応中'
                    } else if (element.state_flg === 2) {
                        element.state_flg_text = '返信済（回答待ち）'
                    } else if (element.state_flg === 3) {
                        element.state_flg_text = '返信済'
                    } else if (element.state_flg === 4) {
                        element.state_flg_text = '完了'
                    } else {
                        element.state_flg_text = ''
                    }
                }
                element.type_text = convertMailTypeToText(element.type, element.kinds_name, element.kinds_state)
                if (element.full_name === null) {
                    element.full_name = '未設定'
                }
                element.inquiry_type_text = convertInquiryTypeToText(element.inquiry_type)
                return element
            })
        }
        state.listMailTrash = result
    },
    SET_SEARCH_FILTER(state, payload){
        state.searchFilter = payload
    },
    CLEAR_SERACH_FILTER(state){
        state.searchFilter = null
    },
    SET_MODE(state) {
        state.mode = !state.mode
    },
}